var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"d-error-page"},[_c('PageHeader',_vm._b({attrs:{"use-wide-image":"","title":_vm.computedTitle}},'PageHeader',{
			..._vm.$attrs,
			..._vm.$props,
		},false)),_vm._v(" "),(_vm.contentElements && _vm.contentElements.length)?_c('BlockList',{staticClass:"relative mt-5xl",attrs:{"block-list":_vm.contentElements},scopedSlots:_vm._u([(_vm.showLongread)?{key:"aside",fn:function(){return [_c('div',{class:[
					'pointer-events-none hidden <1024:h-5xl',
					'>=1024:block >=1024:sticky >=1024:top-6xl',
				]},[_c('div',{class:[
						'w-full',
						'<1024:absolute <1024:h-full <1024:top-0',
					]},[_c('LongRead',{class:[
							'z-30 <1024:mb-5xl',
							'<1024:sticky <1024:top-site-header-compact',
						]})],1)])]},proxy:true}:null],null,true)}):_vm._e(),_vm._v(" "),(
			(_vm.showRelatedPages &&
				_vm.showRelatedPages.links &&
				_vm.showRelatedPages.links.length) ||
			(_vm.showMorePages &&
				_vm.showMorePages.pages &&
				_vm.showMorePages.pages.length)
		)?_c('div',{staticClass:"mt-5xl space-y-5xl"},[(
				_vm.showRelatedPages &&
				_vm.showRelatedPages.links &&
				_vm.showRelatedPages.links.length
			)?_c('RelatedPages',_vm._b({},'RelatedPages',{ ..._vm.showRelatedPages, links: _vm.showRelatedPages.links },false)):_vm._e(),_vm._v(" "),(
				_vm.showMorePages &&
				_vm.showMorePages.pages &&
				_vm.showMorePages.pages.length
			)?_c('RelatedPages',_vm._b({attrs:{"grey":""}},'RelatedPages',{ ..._vm.showMorePages, links: _vm.showMorePages.pages },false)):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }